import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const logEvent = (type, meta = {}) => {
  api.post("/events", { type, meta }).catch(() => {});
};


export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_9fabdcd9-9992-46ce-b8f7-3da73e52f75f/artifacts/gvctzcbx_inbound6273050075905407223.png";

export const BBB_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/mna2zrzy_blue-seal-293-61-bbb-90061218.png";

export const PHONE = "713-904-3904";
export const PHONE_TEL = "+17139043904";

export const DISCLAIMER_TITLE = "Instant Roof Estimate Disclaimer";
export const DISCLAIMER_PARAGRAPHS = [
  "This instant roof estimate is generated automatically using aerial or satellite imagery, measurement algorithms, and standard pricing assumptions. It is intended for preliminary budgeting purposes only and does not constitute a final quote or contractual offer.",
  "Actual project cost may vary based on onsite inspection, roof condition, structural factors, material selection, access, code requirements, and unforeseen conditions not visible in remote data.",
  "A firm proposal will be provided after a qualified representative of Roof Fix Houston, LLC completes an in-person assessment. By using this tool, you acknowledge that the estimate is non-binding and subject to change.",
];

export const CERT_LOGOS = [
  { id: "gaf-residential", alt: "GAF Certified Residential Roofing Contractor", url: "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/4ettthfq_gaf-certified-residential-roofing-contractor.png" },
  { id: "gaf-system-plus", alt: "GAF System Plus Warranty", url: "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/x2z47nnm_gaf-certified-system-plus-warranty-150x150-1.png" },
  { id: "iko-roofpro", alt: "IKO RoofPro Select", url: "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/qcr8cg95_IKO-RoofPro-Select-150x150-1.png" },
  { id: "owens-corning", alt: "Owens Corning Preferred Contractor", url: "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/16shfszw_Owens-Corning-Preferred-Contractor-150x150-1.png" },
  { id: "certainteed", alt: "CertainTeed", url: "https://customer-assets.emergentagent.com/job_roofing-calc-4/artifacts/odj2j8nk_certainteed.png" },
];

export default api;
